<template>
  <v-dialog
    v-model="computedWintertrailsSkirunsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn
          icon
          @click="
            methodToggleListView('wintertrails', 'skiruns');
            search = null;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title class="hidden-sm-and-down">Ski Runs</v-toolbar-title>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-select
          :items="select_mountain_items"
          v-model="select_mountain_model"
          style="padding-top:23px;"
        ></v-select>
        <v-spacer class="hidden-sm-and-down"></v-spacer>
        <v-text-field
          append-icon="search"
          single-line
          hide-details
          v-model="search"
          placeholder="Filter data"
        ></v-text-field>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :headers="headers"
          :items="computedWintertrailsSkirunsGeoJsonFeatures"
          :rows-per-page-items="rows_per_page"
          :rows-per-page-text="rows_per_page_text"
          :search="search"
          class="elevation-1"
          :loading="computedWintertrailsSkirunsLoading"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="
                zoomTo({
                  center: props.item.geometry.coordinates[0][0],
                  level: 18
                });
                methodToggleListView('wintertrails', 'skiruns');
                search = null;
              "
            >
              <td>{{ props.item.properties.mountain }}</td>
              <td>{{ props.item.properties.run_name }}</td>
              <td>{{ props.item.properties.difficulty }}</td>
              <td>{{ props.item.properties.length_m }}</td>
            </tr>
          </template>

          <!-- Alert when no results found -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
"dataWintertrailsSkiruns";
export default {
  data() {
    return {
      select_mountain_items: ["Both Mountains", "Whistler", "Blackcomb"],
      select_mountain_model: "Both Mountains",
      loading: true,
      search: "",
      rows_per_page: [10, 25, 50, { text: "All", value: -1 }],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Mountain",
          value: "properties.mountain"
        },
        {
          text: "Run Name",
          value: "properties.run_name"
        },
        {
          text: "Difficulty",
          value: "properties.difficulty"
        },
        {
          text: "Length in metres",
          value: "properties.length_m"
        }
      ]
    };
  },
  computed: {
    computedWintertrailsSkirunsGeoJsonFeatures() {
      if (
        this.$store.state.mapLayers.wintertrails.layers.skiruns.geojson.features
      ) {
        const skiruns = this.$store.state.mapLayers.wintertrails.layers.skiruns
          .geojson.features;
        switch (this.select_mountain_model) {
          case "Whistler":
            return skiruns.filter(
              item => item.properties.mountain == "Whistler"
            );
          case "Blackcomb":
            return skiruns.filter(
              item => item.properties.mountain == "Blackcomb"
            );
          case "Both Mountains":
            return this.$store.state.mapLayers.wintertrails.layers.skiruns
              .geojson.features;
          default:
            return this.$store.state.mapLayers.wintertrails.layers.skiruns
              .geojson.features;
        }
      }
      return [];
    },
    computedWintertrailsSkirunsVisibility() {
      return this.$store.state.mapLayers.wintertrails.layers.skiruns.visibility
        .listView;
    },
    computedWintertrailsSkirunsLoading() {
      return this.$store.state.mapLayers.wintertrails.layers.skiruns.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    // method to get geojson
    methodGetWintertrailsSkirunsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/wintertrails/skiruns",
        dept: "wintertrails",
        layer: "skiruns",
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.wintertrails.layers.skiruns.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetWintertrailsSkirunsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.wintertrails.layers.skiruns.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
